export default {
  summary: "Sommaire",
  hero: {
    all: {
      title: "Blog",
      subtitle:
        "Tout ce dont vous avez besoin pour passer au solaire en France, par la compagnie solaire.",
    },
    learn: {
      title: "Apprendre",
      subtitle:
        "Guides généraux et contenus préparés par l'équipe éditoriale de Projet Solaire rassemblés à un seul endroit, classés par date.",
    },
    articles: {
      title: "Guide solaire",
      subtitle:
        "Votre guide ultime à l'énergie solaire ! Toutes les infos essentielles qu'il vous faut pour réduire vos coûts et investir dans un avenir meilleur et durable.",
    },
    regulatory: {
      title: "Réglementaire",
      subtitle:
        "Guides généraux et contenus préparés par l'équipe éditoriale de Projet Solaire, rassemblés à un seul endroit, classés par date.",
    },
    testimonials: {
      title: "Témoignages",
      subtitle: "L'avis de nos clients après installation.",
    },
  },
  tabs: {
    all: "Tout",
    learn: "Apprendre",
    articles: "Articles",
    regulatory: "Réglementaire",
    testimonials: "Témoignages",
  },
  "installation-steps": {
    title: "Passer au solaire",
    subtitle:
      "Nous sommes en train de développer une plateforme communautaire sur mesure qui connecte tous les porteurs de projets solaires aux professionnels en photovoltaïque et stockage.",
    "read-more": "Lire la suite",
  },
  featured: {
    title: "Le solaire, en six épisodes",
    subtitle:
      "Découvrez les dernières infos sur l'énergie solaire, appuyées par les réponses à vos questions les plus courantes.",
  },
  latest: {
    title: "Nouveaux articles",
    subtitle:
      "Restez à jour sur les derniers articles provenant de notre équipe éditoriale indépendante.",
    by: "Écrit par ",
    "search-placeholder": "Rechercher tous les articles",
    "see-all": "Voir tout",
  },

  series: {
    topics: "Sujets",
    "bread-crumb": {
      resources: "ressources",
      topics: "sujets",
    },
    "topics-series": {
      supplySideNewsletter: "Le Point Réglementaire",
      stories: "Témoignages",
      "why-go-solar": "Guide d'autonomie solaire",
      "how-to-go-solar": "Comment démarrer ?",
    },
  },
  popular: {
    "popular-on": "Populaire sur Projetsolaire",
    by: "Par ",
  },
  "find-installer": {
    title: "Trouver un installateur :",
    description:
      "Trouvez vos installateur RGE proche de chez vous dès aujourd'hui",
    "learn-more": "En savoir plus",
    "get-quote": "Obtenir un devis",
  },
  regulatory: {
    title: "Réglementaire et Juridique",
    subtitle:
      "Une sélection de nos articles couvrant le point de vue réglementaire lors du passage au solaire.",
    "search-placeholder": "Rechercher réglementaire et juridique",
    "see-all": "Voir tout",
  },
  "image-links": {
    roof: {
      title: "Découvrez votre potentiel solaire",
      description:
        "Analyse rapide de vos économies élec à partir de votre compteur Linky. Nous calculons la valeur énergétique, économique et environnementale de votre gisement solaire.",
    },
    software: {
      title: "Obtenez le meilleur prix",
      description:
        "Choisissez votre prix ! Faites jouer la concurrence, les entreprises veulent gagner votre chantier. Laissez-nous obtenir plusieurs devis complets, détaillés et sur-mesure.",
    },
  },
}
